<template>
  <div class="app-container">
    <Header />
    <HeroSection />
    <PainPoints />  
    <ProductFeatures />
    <AIReviewSystem />
    <DataProcessing />
    <IPMarket />
    <VisionSection />
    <CTASection />
    <Footer />
  </div>
</template>

<script setup>
// ⭐ 使用V4的website组件
import Header from "@/presentation/components/website/Header.vue";
import HeroSection from "@/presentation/components/website/HeroSection.vue";
import PainPoints from "@/presentation/components/website/PainPoints.vue";
import ProductFeatures from "@/presentation/components/website/ProductFeatures.vue";
import AIReviewSystem from "@/presentation/components/website/AIReviewSystem.vue";
import DataProcessing from "@/presentation/components/website/DataProcessing.vue";
import IPMarket from "@/presentation/components/website/IPMarket.vue";
import VisionSection from "@/presentation/components/website/VisionSection.vue";
import CTASection from "@/presentation/components/website/CTASection.vue";
import Footer from "@/presentation/components/website/Footer.vue";
</script>

<style>
:root {
  /* 灰色主色调 */
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-400: #9ca3af;
  --gray-500: #6b7280;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --gray-900: #111827;
  
  /* 强调色使用灰色系中的冷灰 */
  --accent-100: #e5e7eb;  /* 浅灰 */
  --accent-300: #9ca3af;  /* 中灰 */
  --accent-500: #6b7280;  /* 强调主色 */
  --accent-700: #4b5563;  /* 深灰 */
  
  /* 主色调整为灰色系 */
  --primary: var(--accent-500);
  --primary-dark: var(--accent-700);
  
  /* 背景和卡片颜色 */
  --light: var(--gray-50);
  --secondary: var(--gray-800);
  --card-bg: #ffffff;
  
  /* 成功/警告等状态色也调整为灰色系 */
  --success: #6b7280;
  --warning: #4b5563;
  
  /* 阴影优化 */
  --card-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 
                 0 1px 3px rgba(0, 0, 0, 0.1);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app-container {
  font-family: "Inter", sans-serif;
  color: var(--secondary);
  line-height: 1.6;
  background-color: #f8fafc;
  overflow-x: hidden;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  font-size: 16px;
  border: none;
  outline: none;
}

.btn-outline {
  background: transparent;
  border: 2px solid var(--primary);
  color: var(--primary);
}

.btn-outline:hover {
  background: var(--primary);
  color: white;
}

.btn-primary {
  background: var(--gray-600);
  color: white;
  box-shadow: 0 4px 15px rgba(107, 114, 128, 0.3);
}

.btn-primary:hover {
  background: var(--gray-700);
  transform: translateY(-2px);
  box-shadow: var(--btn-primary-hover-shadow, 0 6px 20px rgba(55, 65, 81, 0.35));
}
</style>
